// Validated against the dataviz skill's palette checks (scripts/validate_palette.js).
// Light-mode only — the app has no dark mode elsewhere yet.

// Time-series (views/starts/submissions): brand purple + orange + aqua.
// Validated all-pairs: worst CVD ΔE 9.2 (deutan), worst normal-vision ΔE 27.6.
export const SERIES = {
  submissions: "#eb6834",
  views: "#eb6834",
  starts: "#1baf7a",
} as const;

// Submissions-by-status donut — the skill's documented default 8-hue categorical
// order (validated adjacent-pairs, both modes). Assigned in fixed sequence, never cycled.
export const STATUS_COLORS: Record<string, string> = {
  new: "#2a78d6",
  read: "#eb6834",
  starred: "#1baf7a",
  archived: "#eda100",
  spam: "#e87ba4",
  pending: "#008300",
  approved: "#4a3aa7",
  rejected: "#e34948",
};

export const CHART_CHROME = {
  grid: "#e1e0d9",
  axis: "#898781",
  textSecondary: "#52514e",
  textPrimary: "#0b0b0b",
};
